import React, { useState, useEffect } from 'react';
import '../../css/AdminModal.css'; // Використовуємо ті ж стилі

// Виносимо початковий стан форми для перевикористання
const initialFormState = {
    name_ua: '',
    code1: '',
    code2: '',
    code3: '',
    numerkatalogowy: '',
    price: '',
    originalPrice: '',
    deliveryPrice: '',
    originalId: '',
    link: '',
    photo: '',
    description: '',
    categoryId: '',
    brandId: '',
    modelId: '',
};

const ProductModal = ({ isOpen, onClose, onSave, initialData = {}, categories = [], brands = [], models = [], isSaving = false }) => {
    // Ініціалізуємо стан одразу з усіма ключами
    const [formData, setFormData] = useState(initialFormState);
    // Стан для фільтрованих моделей (залежно від обраної марки)
    const [filteredModels, setFilteredModels] = useState([]);

    // Ініціалізація/скидання форми при відкритті
    useEffect(() => {
        if (isOpen) {
            console.log('[ProductModal] Setting form data with initialData:', initialData);
            const newFormData = {
                id: initialData.id || undefined, // Зберігаємо ID для редагування
                name_ua: initialData.name_ua || '',
                code1: initialData.code1 || '',
                code2: initialData.code2 || '',
                code3: initialData.code3 || '',
                numerkatalogowy: initialData.numerkatalogowy || '',
                price: initialData.price === null || initialData.price === undefined ? '' : initialData.price,
                originalPrice: initialData.originalPrice === null || initialData.originalPrice === undefined ? '' : initialData.originalPrice,
                deliveryPrice: initialData.deliveryPrice === null || initialData.deliveryPrice === undefined ? '' : initialData.deliveryPrice,
                originalId: initialData.originalId === null || initialData.originalId === undefined ? '' : initialData.originalId,
                link: initialData.link || '',
                photo: initialData.photo || '',
                description: initialData.description || '',
                categoryId: initialData.categoryId || initialData.category?.id || '',
                brandId: initialData.brandId || initialData.model?.brand?.id || '',
                modelId: initialData.modelId || initialData.model?.id || '',
            };
            console.log('[ProductModal] New form data:', newFormData);
            setFormData(newFormData);
        } 
    }, [isOpen, initialData]);

    // Фільтрація моделей при зміні марки
    useEffect(() => {
        if (formData.brandId) {
            // Підтримуємо обидві структури: model.brandId та model.brand.id
            const filtered = models.filter(model => {
                const modelBrandId = model.brandId || model.brand?.id;
                return modelBrandId === Number(formData.brandId);
            });
            setFilteredModels(filtered);
            // Якщо вибрана модель не належить до нової марки, скидаємо її
            if (formData.modelId) {
                const isModelValid = filtered.some(model => model.id === Number(formData.modelId));
                if (!isModelValid) {
                    setFormData(prev => ({ ...prev, modelId: '' }));
                }
            }
        } else {
            setFilteredModels([]);
            setFormData(prev => ({ ...prev, modelId: '' }));
        }
    }, [formData.brandId, models]);

    // Блокування скролу body коли модалка відкрита
    useEffect(() => {
        if (isOpen) {
            // Зберігаємо поточну позицію скролу
            const scrollY = window.scrollY;
            
            // Блокуємо скрол на body і html
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
            
            return () => {
                // Відновлюємо скрол
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.width = '';
                document.body.style.overflow = '';
                document.documentElement.style.overflow = '';
                
                // Повертаємо позицію скролу
                window.scrollTo(0, scrollY);
            };
        }
    }, [isOpen]);

    if (!isOpen) {
        return null;
    }

    // Обробник зміни значень у полях форми
    const handleChange = (e) => {
        const { name, value, type } = e.target;
        console.log('[ProductModal] handleChange - Name:', name, 'Value:', value);
        setFormData(prev => ({
            ...prev,
            // Конвертуємо числові значення одразу
            [name]: type === 'number' ? (value === '' ? '' : Number(value)) : value
        }));
    };

    // Обробник збереження
    const handleSave = () => {
        const dataToSave = {
            ...formData,
            categoryId: formData.categoryId === '' ? null : Number(formData.categoryId),
            price: formData.price === '' ? null : Number(formData.price),
            originalPrice: formData.originalPrice === '' ? null : Number(formData.originalPrice),
            deliveryPrice: formData.deliveryPrice === '' ? null : Number(formData.deliveryPrice),
            originalId: formData.originalId === '' ? null : Number(formData.originalId),
            modelId: formData.modelId === '' ? null : Number(formData.modelId),
        };
        // Видаляємо brandId з dataToSave, оскільки на бекенді зберігається тільки modelId
        delete dataToSave.brandId;
        onSave(dataToSave);
        onClose();
    };

    console.log('[ProductModal] Current formData:', formData);

    return (
        <div className="admin-modal-backdrop" onClick={onClose}>
            <div className="admin-modal-content product-modal-content" onClick={e => e.stopPropagation()}>
                {/* Заголовок може змінюватись залежно від того, створення це чи редагування */} 
                <h3>{initialData.id ? 'Редагувати товар' : 'Створити новий товар'}</h3>
                
                <div className="modal-form-fields">
                    <div className="modal-input-container">
                    <label htmlFor="productName">Назва:</label>
                    <textarea
                        id="productName"
                        name="name_ua"
                        value={formData.name_ua}
                        onChange={handleChange}
                        className="modal-input modal-input-textarea"
                        rows={3}
                    />
                </div>

                <div className="modal-input-container">
                    <label htmlFor="productCode1">Код 1:</label>
                    <input
                        type="text"
                        id="productCode1"
                        name="code1"
                        value={formData.code1}
                        onChange={handleChange}
                        className="modal-input modal-input-text"
                    />
                </div>

                <div className="modal-input-container">
                    <label htmlFor="productCode2">Код 2:</label>
                    <input
                        type="text"
                        id="productCode2"
                        name="code2"
                        value={formData.code2}
                        onChange={handleChange}
                        className="modal-input modal-input-text"
                    />
                </div>

                <div className="modal-input-container">
                    <label htmlFor="productCode3">Код 3:</label>
                    <input
                        type="text"
                        id="productCode3"
                        name="code3"
                        value={formData.code3}
                        onChange={handleChange}
                        className="modal-input modal-input-text"
                    />
                </div>

                <div className="modal-input-container">
                    <label htmlFor="productNumerKatalogowy">Номер каталоговий:</label>
                    <input
                        type="text"
                        id="productNumerKatalogowy"
                        name="numerkatalogowy"
                        value={formData.numerkatalogowy}
                        onChange={handleChange}
                        className="modal-input modal-input-text"
                    />
                </div>

                <div className="modal-input-container">
                    <label htmlFor="productPrice">Ціна:</label>
                    <input
                        type="number"
                        id="productPrice"
                        name="price"
                        value={formData.price}
                        onChange={handleChange}
                        className="modal-input modal-input-number"
                        step="0.01"
                    />
                </div>

                <div className="modal-input-container">
                    <label htmlFor="productOriginalPrice">Оригінальна ціна:</label>
                    <input
                        type="number"
                        id="productOriginalPrice"
                        name="originalPrice"
                        value={formData.originalPrice}
                        onChange={handleChange}
                        className="modal-input modal-input-number"
                        step="0.01"
                    />
                </div>

                <div className="modal-input-container">
                    <label htmlFor="productDeliveryPrice">Ціна доставки:</label>
                    <input
                        type="number"
                        id="productDeliveryPrice"
                        name="deliveryPrice"
                        value={formData.deliveryPrice}
                        onChange={handleChange}
                        className="modal-input modal-input-number"
                        step="0.01"
                    />
                </div>

                <div className="modal-input-container">
                    <label htmlFor="productOriginalId">Original ID:</label>
                    <input
                        type="number"
                        id="productOriginalId"
                        name="originalId"
                        value={formData.originalId}
                        onChange={handleChange}
                        className="modal-input modal-input-number"
                    />
                </div>

                <div className="modal-input-container">
                    <label htmlFor="productLink">Посилання:</label>
                    <textarea
                        id="productLink"
                        name="link"
                        value={formData.link}
                        onChange={handleChange}
                        className="modal-input modal-input-textarea"
                        rows={2}
                    />
                </div>

                <div className="modal-input-container">
                    <label htmlFor="productPhoto">Фото URL:</label>
                    <input
                        type="text"
                        id="productPhoto"
                        name="photo"
                        value={formData.photo}
                        onChange={handleChange}
                        className="modal-input modal-input-text"
                    />
                </div>

                <div className="modal-input-container">
                    <label htmlFor="productDescription">Опис:</label>
                    <textarea
                        id="productDescription"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        className="modal-input modal-input-textarea"
                        rows={5}
                    />
                </div>
                
                <div className="modal-input-container">
                    <label htmlFor="productCategory">Категорія:</label>
                    <select
                        id="productCategory"
                        name="categoryId"
                        value={formData.categoryId}
                        onChange={handleChange}
                        className="modal-input modal-input-select"
                        required
                    >
                        <option value="" disabled>-- Виберіть категорію --</option>
                        {categories.map(cat => (
                            <option key={cat.id} value={cat.id}>
                                {cat.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="modal-input-container">
                    <label htmlFor="productBrand">Марка автомобіля (опціонально):</label>
                    <select
                        id="productBrand"
                        name="brandId"
                        value={formData.brandId}
                        onChange={handleChange}
                        className="modal-input modal-input-select"
                    >
                        <option value="">-- Не вибрано --</option>
                        {brands.map(brand => (
                            <option key={brand.id} value={brand.id}>
                                {brand.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="modal-input-container">
                    <label htmlFor="productModel">Модель автомобіля (опціонально):</label>
                    <select
                        id="productModel"
                        name="modelId"
                        value={formData.modelId}
                        onChange={handleChange}
                        className="modal-input modal-input-select"
                        disabled={!formData.brandId}
                    >
                        <option value="">-- Не вибрано --</option>
                        {filteredModels.map(model => (
                            <option key={model.id} value={model.id}>
                                {model.name}
                            </option>
                        ))}
                    </select>
                    {!formData.brandId && (
                        <small style={{ color: '#666', fontSize: '12px' }}>
                            Спочатку оберіть марку
                        </small>
                    )}
                </div>
                </div>

                <div className="modal-actions">
                    <button onClick={handleSave} className="modal-save-button" disabled={isSaving}>
                        {isSaving ? 'Збереження...' : 'Зберегти'}
                    </button>
                    <button onClick={onClose} className="modal-cancel-button" disabled={isSaving}>Скасувати</button>
                </div>
            </div>
        </div>
    );
};

export default ProductModal; 